import { render, staticRenderFns } from "./Flask.vue?vue&type=template&id=6477d782&scoped=true&"
import script from "./Flask.vue?vue&type=script&lang=js&"
export * from "./Flask.vue?vue&type=script&lang=js&"
import style0 from "./Flask.vue?vue&type=style&index=0&id=6477d782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6477d782",
  null
  
)

export default component.exports